import { render, staticRenderFns } from "./PuppyReleaseSignature.vue?vue&type=template&id=d2f4f2c8"
import script from "./PuppyReleaseSignature.vue?vue&type=script&lang=ts"
export * from "./PuppyReleaseSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports